<template>
  <div class="app-container">
    <Header></Header>
    <div class="top">
      <div class="title">重磅嘉宾</div>
    </div>
    <div class="guest-list">
      <div class="guest-content">
        <div
          class="guest-item"
          v-for="(item, index) in nowGuestList"
          :key="index"
          @click="didClick_selguest(item)"
        >
          <div class="box cs">
            <img
              class="guest-box-bg-pc"
              src="../../assets/images/guest/guest-bg.png"
            />
            <img class="guest-photo" :src="item.realPath_new" />
            <div class="info">
              <div class="name flex">
                <div class="redbox"></div>
                {{ item.name }}
              </div>
              <div class="redbox-a"></div>
              <div
                class="position ellipsis-2"
                v-html="item.enterprise + item.duty"
              ></div>
            </div>
          </div>
        </div>
      </div>
      <div class="text-center" v-if="false">
        <el-pagination
          background
          :prev-text="'上一页'"
          :next-text="'下一页'"
          :page-size="pageSize"
          :pager-count="5"
          @current-change="onChange"
          layout="prev, pager, next, slot"
          :total="guests.length"
        >
          <template
            ><span class="total">
              共{{ Math.ceil(guests.length / 9) }}页
            </span></template
          >
        </el-pagination>
      </div>
    </div>
    <suspension></suspension>
    <cook-tip></cook-tip>
    <foot class="foot2"></foot>
    <custom-dialog
      :width="$store.state.isMobile ? '80%' : '730px'"
      ref="guestDialog"
      @closePop="closePopup"
      @afterClose="afterClose"
    >
      <div v-if="nowGuest" class="box-top flex align-center">
        <div class="photo">
          <img class="guest-photo" :src="nowGuest.realPath_new" />
        </div>
        <div class="inof">
          <div class="name">{{ nowGuest.name }}</div>
          <div class="redbox"></div>
          <div
            class="position"
            v-html="nowGuest.enterprise + nowGuest.duty"
          ></div>
        </div>
      </div>
      <div v-if="nowGuest" class="box-down">
        <div class="title">
          <div class="name">演讲议程</div>
          <img class="long-img" src="@/assets/images/guest/popup/longImg.png" />
        </div>
        <div class="content">
          <div
            class="schedule-box"
            :key="index"
            v-for="(seminar, index) in nowGuest.subSeminarList"
          >
            <div class="title2 flex align-start">
              <div class="circle-box">
                <div class="circle"></div>
              </div>

              <div class="name">{{ seminar.name }}</div>
            </div>
            <div class="detail flex align-start">
              <div class="icon-detail flex align-center">
                <img src="@/assets/images/guest/popup/clock.png" />
                <div class="text">
                  {{ seminar.startTime | getDate }}
                  {{ seminar.startTime | getTime }}-{{
                    seminar.endTime | getTime
                  }}
                </div>
              </div>
              <div class="icon-detail flex align-start" v-show="seminar.hotel">
                <img src="@/assets/images/guest/popup/place.png" />
                <div class="text">{{ seminar.hotel }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </custom-dialog>
  </div>
</template>

<script>
import Header from "../../components/Header";
import Foot from "../../components/Foot";
import CookTip from "../../components/CookTip";
import { staticApi } from "../../services";
import Suspension from "../../components/Suspension";
import moment from "moment";

export default {
  name: "Guest",
  data() {
    return {
      guests: [],
      nowGuest: null,
      selectGuest: false,
      nowGuestList: [],
      page: 1, //当前页数
      pageSize: 9, //每页显示条数
    };
  },
  components: {
    Header,
    Foot,
    CookTip,
    Suspension,
    CustomDialog: () => import("../../components/dialog/CustomDialog"),
  },
  filters: {
    getDate: (time) => {
      let MM = moment(time * 1000).format("MM");
      let DD = moment(time * 1000).format("DD");
      let Date =
        (MM[0] == "0" ? MM[1] : MM) + "月" + (DD[0] == "0" ? DD[1] : DD) + "日";
      return Date;
    },
    getTime: (time) => {
      return moment(time * 1000).format("HH:mm");
    },
  },
  computed: {},
  created() {
    this.getList();
  },
  methods: {
    itemRender(urrent, type, originalElement) {
      if (type === "prev") {
        return <a class="prev_next">上一页</a>;
      } else if (type === "next") {
        return <a class="prev_next">下一页</a>;
      }
      return originalElement;
    },
    onChange(page) {
      this.page = page;
      this.nowGuestList = this.guests.slice(
        (page - 1) * this.pageSize,
        page * this.pageSize
      );
    },
    getList() {
      // 嘉宾列表
      staticApi
        .request(
          `/${this.$config.tenantId}/seminar/${this.$config.guestListId}/guest.json`
        )
        .then((res) => {
          if (res.result == 0) {
            let guests = res.content.filter((guest) => {
              return guest.isPublic === "是";
            });
            //排序 有自定义使用自定义  无自定义 使用创建时间倒叙
            guests.forEach((item) => {
              item.realPath_new = "";
              if (item.realPath) {
                item.realPath_new = item.realPath.replace(
                  /^.*\/\/hwyhw.smarket.net.cn/,
                  "https://hwyhw-files.smarket.net.cn"
                );
              }
            });
            guests.sort((a, b) => {
              if (a.guestsOrder == b.guestsOrder) {
                //若排序相等 比较 开始时间 和结束时间
                const aCreated_at = new Date(a.createTime).getTime();
                const bCreated_at = new Date(b.createTime).getTime();
                //创建时间倒叙 排序
                return bCreated_at - aCreated_at;
              }
              return b.guestsOrder - a.guestsOrder;
            });

            this.guests = guests;
            this.nowGuestList = this.$store.state.isMobile
              ? guests
              : guests.slice(0, this.pageSize);
          }
        })
        .catch((error) => {});
    },
    didClick_selguest(option) {
      window._hw("send", "action", "guest_information_click", {
        guest_name: option.option, // 名称
        guest_company: option.enterprise, // 公司
      });
      this.$api
        .getGuest({
          guestId: option.seminarGuestId,
        })
        .then((res) => {
          this.nowGuest = option;
          this.nowGuest.subSeminarList = res.content.subSeminarList.sort(
            (a, b) => {
              if (b.startTime - a.startTime !== 0) {
                return a.startTime - b.startTime;
              }
              if (b.endTime - a.endTime !== 0) {
                return a.endTime - b.endTime;
              }
              return a.createTime - b.createTime;
            }
          );
          //console.log(this.nowGuest);
          this.$nextTick(() => {
            //this.selectGuest = true;
            this.$refs.guestDialog.showDialog();
          });
        });
    },
    //关闭弹窗
    closePopup() {
      this.selectGuest = false;
    },
    afterClose() {
      this.nowGuest = null;
    },
  },
};
</script>

<style lang="scss" scoped>
@media screen and (min-width: 992px) {
  @import "./css/index/pc.scss";
}

@media screen and (max-width: 992px) {
  @import "./css/index/wap.scss";
}
</style>
